module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Haegglingen-375848e065e36031a66f9c11d08e4f48.svg";